// picker_raycast.js
var PickerRaycast = pc.createScript('pickerRaycast');


// initialize code called once per entity
PickerRaycast.prototype.initialize = function() {
    this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onSelect, this);
    self = this;
};

PickerRaycast.prototype.onSelect = function (e) {
    var from = this.entity.camera.screenToWorld(e.x, e.y, this.entity.camera.nearClip);
    var to = this.entity.camera.screenToWorld(e.x, e.y, this.entity.camera.farClip);
//     this.app.systems.rigidbody.raycastFirst(from, to, function (result) { 
//     });
       var pickedEntity = this.app.systems.rigidbody.raycastFirst(from, to); //result.entity;

       if(pickedEntity !== null){

         // console.log('pe: ' + pickedEntity.entity.name);
         // this.app.fire('userInput:objectSelected', pickedEntity.entity);
       }   
};


